(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4566],{

/***/ 64814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var components_PurchaseSummaryPage_PurchaseSummaryPage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85776);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var PurchaseSummary = function PurchaseSummary() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_PurchaseSummaryPage_PurchaseSummaryPage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {});
};

/* harmony default export */ __webpack_exports__["default"] = (PurchaseSummary);

/***/ }),

/***/ 28415:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quick-purchase/purchase-summary",
      function () {
        return __webpack_require__(64814);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,2726,3450,2198,2663,3818,4055,1456,9904,8643,2563,3050,5776,9774,2888,179], function() { return __webpack_exec__(28415); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);